"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Tag_1 = require("./_Tag");
var _LifecycleRuleAndOperator_1 = require("./_LifecycleRuleAndOperator");
exports._LifecycleRuleFilter = {
    type: "structure",
    required: [],
    members: {
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Tag: {
            shape: _Tag_1._Tag
        },
        And: {
            shape: _LifecycleRuleAndOperator_1._LifecycleRuleAndOperator
        }
    }
};
//# sourceMappingURL=_LifecycleRuleFilter.js.map